import { Link2, Truck, Sparkles } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

/**
 * Landing V2 — Features (quiet). Flat, no section padding or borders.
 */
export function FeaturesQuiet() {
  const { t } = useLanguage();

  return (
    <section className="relative px-6">
      <div className="max-w-4xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
          {/* Intake */}
          <div className="space-y-3">
            <div className="flex items-center gap-2.5">
              <Link2 className="h-4 w-4 text-primary" />
              <h2 className="text-base font-semibold text-foreground tracking-tight">
                {t("landing.features.intake.title")}
              </h2>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {t("landing.features.intake.description")}
            </p>
          </div>

          {/* Courier */}
          <div className="space-y-3">
            <div className="flex items-center gap-2.5">
              <Truck className="h-4 w-4 text-primary" />
              <h2 className="text-base font-semibold text-foreground tracking-tight">
                {t("landing.features.courier.title")}
              </h2>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {t("landing.features.courier.description")}
            </p>
          </div>
        </div>

        {/* Quiet AI line */}
        <div className="mt-6 flex items-center justify-center gap-2 text-xs text-muted-foreground/80">
          <Sparkles className="h-3.5 w-3.5 text-primary/60" />
          <p className="text-center max-w-md leading-relaxed">
            {t("landing.features.aiWhisper")}
          </p>
        </div>
      </div>
    </section>
  );
}
